import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { putSaga } from "src/request/put";
import { postSaga } from "../../request/post";
import { SagaActionParams, SagaGenericParams } from "../../request/types";
import * as T from "./type";

export const getUserListSaga = createAction(
  "GET_USER_LIST",
  ({ payload, params }: SagaActionParams<T.UserDto[]>) => ({
    payload,
    url: "/api/appuser/admin" + (params ?? ""),
  })
);
export const getUserDetailSaga = createAction(
  "GET_USER_DETAILS",
  ({ payload, id }: SagaActionParams<T.UserDetailDto>) => ({
    payload,
    url: "/api/appuser/admin/" + id,
  })
);

export const createUserSaga = createAction(
  "CREATE_USER_SAGA",
  ({ payload, body }: SagaActionParams<T.UserDto>) => ({
    payload,
    url: "/api/appuser/admin",
    body,
  })
);
export const changeUserPassword = createAction(
  "CHANGE_USER_PASSWORD_ADMIN",
  ({ payload, body, id }: SagaActionParams<T.UserDto>) => ({
    payload,
    url: "/api/appuser/change-user-password/" + id,
    body,
  })
);
export const updateUserSaga = createAction(
  "UPDATE_USER_SAGA",
  ({ payload, body, id }: SagaActionParams<T.UserDto>) => ({
    payload,
    url: "/api/appuser/admin/" + id,
    body,
  })
);
export const deleteUserSaga = createAction(
  "DELETE_USER_SAGA",
  ({ payload, id }: SagaActionParams<T.UserDto>) => ({
    payload,
    url: "/api/appuser/admin/" + id,
  })
);

const userSaga = [
  takeLatest<any>(
    getUserListSaga.toString(),
    (payload: SagaGenericParams<T.UserDto[]>) => getSaga<T.UserDto[]>(payload)
  ),
  takeLatest<any>(
    getUserDetailSaga.toString(),
    (payload: SagaGenericParams<T.UserDetailDto>) =>
      getSaga<T.UserDetailDto>(payload)
  ),
  takeLatest<any>(
    changeUserPassword.toString(),
    (payload: SagaGenericParams<T.UserDto>) => putSaga<T.UserDto>(payload)
  ),
  takeLatest<any>(
    createUserSaga.toString(),
    (payload: SagaGenericParams<T.UserDto>) => postSaga<T.UserDto>(payload)
  ),
  takeLatest<any>(
    updateUserSaga.toString(),
    (payload: SagaGenericParams<T.UserDto>) => putSaga<T.UserDto>(payload)
  ),
  takeLatest<any>(
    deleteUserSaga.toString(),
    (payload: SagaGenericParams<T.UserDto>) => deleteSaga<T.UserDto>(payload)
  ),
];

export default userSaga;
